export default __webpack_public_path__ + "static/media/3.4953fba4.mp4";